// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ZD6sWh4R","tooltip":"_1QdMwlnr","top":"_1xzt7zKk","bottom":"_2RUcTSuh","right":"_3xf_Og-I","left":"_1r5yDM2S"};